import {getTimeOfDay, safeParse} from "../utils/date-formatters.mjs";

export default async function getPerformances() {
    try {
        const response = await fetch('/api/event-instances.json');
        const data = await response.json();

        return processPerformances(data.docs);
    } catch (error) {
        console.error('Failed to load events:', error);

        throw error;
    }
}

function processPerformances(performances) {
    const now = new Date();

    return performances
        .map(performance => {
            const startDate = safeParse(performance.startDateLocalAsUTC);

            performance.startDate = startDate;
            performance.timeOfDay = getTimeOfDay(startDate);

            if (AppConfig.boDomain) {
                performance.bookButton = {
                    title: 'Buy Buttons',
                    link: `${AppConfig.boDomain.replace(/^\/|\/$/g, '')}/booking/production/${performance.tessitura.performanceId}`
                };
            } else if (AppConfig.tnewDomain) {
                performance.bookButton = {
                    title: 'Buy Buttons',
                    link: `${AppConfig.tnewDomain.replace(/^\/|\/$/g, '')}/${performance.tessitura.productionSeasonId}/${performance.tessitura.performanceId}`
                };
            } else {
                performance.bookButton = null;
            }

            // Handles overrides on the Basker instances
            if (performance.booking.bookingLinkURL) {
                performance.bookButton = performance.bookButton || {};
                performance.bookButton.link = performance.booking.bookingLinkURL;
            }
            if (performance.booking.bookingLinkLabel && performance.bookButton) {
                performance.bookButton.title = performance.booking.bookingLinkLabel;
            }

            return performance;
        })
        .filter(performance => performance.startDate >= now);
}
